import {
  Alert,
  Button,
  Card,
  Col,
  Form,
  Input,
  message,
  Row,
  Spin,Select,
  Typography,
} from "antd";
import React, { Fragment, useState } from "react";
import { Link, withRouter } from "react-router-dom";
import { useAuthContext } from "../../context/AuthContext";
import useScreenSize from "../../hooks/useScreenSize";
import { API } from "../../constant";
import { setToken, setExpire } from "../../helpers";

const { Option } = Select;

const PasswordReset = (props) => {
  const { isDesktopView } = useScreenSize();

  const { setUser, setUserAndPlan } = useAuthContext();

  const [isLoading, setIsLoading] = useState(false);

  const [error, setError] = useState("");

  const onFinish = async (values) => {
    setIsLoading(true);
    const urlParams = new window.URLSearchParams(window.location.search);
    const code = urlParams.get('code');

    try {
      const response = await fetch(`${API}/auth/reset-password`, {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
            code,
            password: values.password,
            passwordConfirmation: values.passwordConfirmation,
        }),
      });

      const data = await response.json();
      if ((data || {}).error) {
        message.error('Es ist etwas schief gelaufen - sind beide Passwörter gleich?');
        console.error((data || {}).error);
      } else {
        message.success('Passwort wurde geändert!');
        props.history.push("/signin");
      }
    } catch (error) {
      console.error(error);
      setError((error || {}).message || "Etwas lief schief - sind beide Passwörter gleich?");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Fragment>
      <Row align="middle">
        <Col span={isDesktopView ? 8 : 24} offset={isDesktopView ? 8 : 0}>
          <Card title="Registrieren">
            {error ? (
              <Alert
                className="alert_error"
                message={error}
                type="error"
                closable
                afterClose={() => setError("")}
              />
            ) : null}
            <Form
              name="basic"
              layout="vertical"
              onFinish={onFinish}
              autoComplete="off"
            >

              <Form.Item
                label="Passwort"
                name="password"
                rules={[{ required: true }]}
              >
                <Input.Password placeholder="Passwort" />
              </Form.Item>
              <Form.Item
                label="Passwort Wiederholen"
                name="passwordConfirmation"
                rules={[{ required: true }]}
              >
                <Input.Password placeholder="Passwort Wiederholen" />
              </Form.Item>

              <Form.Item>
                <Button
                  type="primary"
                  htmlType="submit"
                  className="login_submit_btn"
                >
                  Passwort bestätigen {isLoading && <Spin size="small" />}
                </Button>
              </Form.Item>
            </Form>
            <Typography.Paragraph className="form_help_text">
              Sie haben schon ein Nutzerkonto? <Link to="/signin">Zur Anmeldung</Link>
            </Typography.Paragraph>
          </Card>
        </Col>
      </Row>
    </Fragment>
  );
};

export default withRouter(PasswordReset);
